import { Text } from '@wework/dieter-ui'
import React, { FunctionComponent } from 'react'
import IMTheme from '../../../style/IMTheme'
import { getType } from '../../../utils/spaces'

interface SpaceNameHeaderProps {
  space: any
}
const SpaceNameHeader: FunctionComponent<SpaceNameHeaderProps> = ({
  space,
}) => {
  return (
    <div>
      <Text
        style={{
          fontWeight: IMTheme.fontWeights.bold,
          fontSize: IMTheme.fontSizes[3],
          textTransform: 'capitalize',
        }}
      >
        Space
      </Text>
      <Text style={{ fontSize: IMTheme.fontSizes[5] }}>{space?.number}</Text>
      <Text
        style={{
          textTransform: 'capitalize',
          fontSize: IMTheme.fontSizes[2],
        }}
      >
        {getType(space)}
      </Text>
    </div>
  )
}

export default SpaceNameHeader
